import styled from 'styled-components'

import theme from 'theme'

export const FlexContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;

  @media screen and (max-width: ${theme.breakpoints.sm}px) {
    justify-content: center;
    min-height: calc(100vh - 80px);
  }
`

export const ButtonContainer = styled.div`
  @media screen and (max-width: ${theme.breakpoints.sm}px) {
    position: sticky;
    bottom: 0;
    padding-bottom: 20px;
    width: 100%;
  }
`

export const StyledImage = styled.img`
  @media screen and (max-width: ${theme.breakpoints.sm}px) {
    width: 100%;
    max-width: 236px;
  }
`

export const Title = styled.h1`
  font-size: 22px;
  line-height: 30px;
  margin: 30px 0 10px;
`

export const Body = styled.p`
  font-size: 14px;
  line-height: 22px;
  margin: 10px 0 80px;

  @media screen and (min-width: ${theme.breakpoints.md}px) {
    padding: 0 180px;
  }
`
